import React from 'react';
import { MenuItem, Select } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { InventoryStatus, SingleInventoryItem } from 'common/modules/inventory';
import { InventoryStatuses } from 'common/modules/inventory/constants';
import { getTypedKeys } from 'common/utils/objects';
import { getStatusHighlightColor } from '../utils';
import { getInventoryStatusTranslation } from '../../utils';
import { useTranslation } from 'services/localization';
import { useWatch, useFormContext, Controller } from 'react-hook-form';

const inventoryStatusesList = getTypedKeys(InventoryStatuses);

interface Props {
	item: SingleInventoryItem;
	status: InventoryStatus;
}

const SingleStatus = (props: Props) => {
	const { t } = useTranslation();
	const { control } = useFormContext();

	const status: InventoryStatus = useWatch({
		control,
		name: 'status',
		defaultValue: props.status,
	});
	const classes = useStyles({ status });

	return (
		<Controller
			name="status"
			control={control}
			render={(renderProps) => (
				<Select
					value={renderProps.field.value}
					onChange={renderProps.field.onChange}
					variant="outlined"
					fullWidth
					classes={{
						select: classes.select,
					}}
					inputProps={{
						classes: {
							focused: classes.select,
						},
					}}
				>
					{inventoryStatusesList.map((status, idx) => {
						return (
							<MenuItem key={`${status}${idx}`} value={status}>
								{getInventoryStatusTranslation(t, status)}
							</MenuItem>
						);
					})}
				</Select>
			)}
		/>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		select: {
			backgroundColor: ({ status }: { status: InventoryStatus }) =>
				getStatusHighlightColor(status, theme),
			'&:focus': {
				backgroundColor: ({ status }: { status: InventoryStatus }) =>
					getStatusHighlightColor(status, theme),
			},
		},
	}),
);

export default SingleStatus;
